import type { Dimension, DateDimension, Attribute, DataSourceInfo } from '@sisense/sdk-data';

import { createAttribute, createDateDimension, createDimension } from '@sisense/sdk-data';

const dataSourceName = process.env.NODE_ENV === 'production' ? 'BC_NA_PRODUCTION_DATA_SOURCE_V_0_0_1' : 'BC_NA_STAGING_DATA_SOURCE_V_0_0_1';

export const DataSource: DataSourceInfo = {
  title: dataSourceName,
  type: 'live',
};

interface NextActionDimension extends Dimension {
  action_type_name: Attribute;
  done_by_name: Attribute;
  NextAction_id: Attribute;
  is_done: Attribute;
  priority_name: Attribute;
  owner_name: Attribute;
  done_at_jst: DateDimension;
  first_set_up_at_jst: DateDimension;
  reserved_at_jst: DateDimension;
}
export const NextAction = createDimension({
  name: 'NextAction',
  action_type_name: createAttribute({
    name: 'action_type_name',
    type: 'text-attribute',
    expression: '[次のアクション.次のアクションタイプ]',
    dataSource: { title: dataSourceName, live: true },
  }),
  done_by_name: createAttribute({
    name: 'done_by_name',
    type: 'text-attribute',
    expression: '[次のアクション.次のアクション完了日時]',
    dataSource: { title: dataSourceName, live: true },
  }),
  NextAction_id: createAttribute({
    name: '[NextAction.id]',
    type: 'numeric-attribute',
    expression: '[次のアクション.次のアクションID]',
    dataSource: { title: dataSourceName, live: true },
  }),
  is_done: createAttribute({
    name: 'is_done',
    type: 'text-attribute',
    expression: '[次のアクション.完了済み次のアクション]',
    dataSource: { title: dataSourceName, live: true },
  }),
  priority_name: createAttribute({
    name: 'priority_name',
    type: 'text-attribute',
    expression: '[次のアクション.次のアクション優先度]',
    dataSource: { title: dataSourceName, live: true },
  }),
  owner_name: createAttribute({
    name: 'owner_name',
    type: 'text-attribute',
    expression: '[次のアクション.次のアクション所有者]',
    dataSource: { title: dataSourceName, live: true },
  }),
  done_at_jst: createDateDimension({
    name: 'done_at_jst',
    expression: '[次のアクション.次のアクション完了日時 (Calendar)]',
    dataSource: { title: dataSourceName, live: true },
  }),
  first_set_up_at_jst: createDateDimension({
    name: 'first_set_up_at_jst',
    expression: '[次のアクション.次のアクション作成日時 (Calendar)]',
    dataSource: { title: dataSourceName, live: true },
  }),
  reserved_at_jst: createDateDimension({
    name: 'reserved_at_jst',
    expression: '[次のアクション.次のアクション予定日時 (Calendar)]',
    dataSource: { title: dataSourceName, live: true },
  }),
}) as NextActionDimension;

export const Tenant = createDimension({
  name: 'Tenant',
  Tenant_id: createAttribute({
    name: '[Tenant.id]',
    type: 'numeric-attribute',
    expression: '[テナント情報.テナントID]',
    dataSource: { title: dataSourceName, live: true },
  }),
});
